import { SvgIcon, Tooltip } from "@mui/material";
// import {ReactComponent as  IconSquareCrossingDottedLines} from '../../../images/panels.svg';
import {ReactComponent as  IconSquareCrossingDottedLines} from '../../../images/canvas-tiles.svg';
import { useCanvasTilesStore } from "../../store/canvas-tiles";
import ToggleFab from "../ToggleFab";

export const CanvasTilesTool = () => {
  const {shown, setShown} = useCanvasTilesStore();
  return (
    <Tooltip title="Mostra i teli" placement="top">
      <ToggleFab
        active={shown}
        onClick={() => setShown(!shown)}
      >
        <SvgIcon component={IconSquareCrossingDottedLines} inheritViewBox />
      </ToggleFab>
    </Tooltip>
  )
};